<script>
    export let data = [];
    export let excludeKeys = [];
    const displayKeys = data.filter(
        (e) =>
            e !== null &&
            typeof e !== "undefined" &&
            e.key !== null &&
            typeof e.key !== "undefined" &&
            !excludeKeys.includes(e.key)
    );
</script>

<!--src/components/DataGrid.svelte-->
<!-- DataGrid simply prints out the key and value of each object contained in the list @data -->
<dl>
    {#each displayKeys as d}
        <dt>{d.key}</dt>
        <dd>{d.value}</dd>
    {/each}
</dl>

<style>
    dl {
        display: flex;
        align-items: center;
        flex-flow: row wrap;
    }
    dt {
        min-width: 128px;
        flex: 1 0 30%;
        margin: 8px auto;
    }
    dd {
        flex: 1 0 60%;
        margin-left: 0px;
        width: 60%;
        font-weight: 700;
    }
</style>
